// @flow

import React, { Component, Fragment } from 'react';

import { loadDynamicScript } from 'clark-utils';

import { PlaidButton, PlaidTextLink } from './styles';

const publicKey = process.env.REACT_APP_PLAID_PUBLIC_KEY;
const initializeURL = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';

const getPlaidEnv = () =>
  ({
    development: 'sandbox',
    qa: 'sandbox',
    staging: 'production',
    production: 'production',
  }[process.env.REACT_APP_NODE_ENV || 'development']);

const handleOnClick = () => window.plaidLinkHandler && window.plaidLinkHandler.open();

class PlaidLink extends Component<*, void> {
  componentWillMount() {
    const {
      apiVersion = 'v2',
      clientName,
      env = getPlaidEnv(),
      onSuccess,
      selectAccount = false,
      token = null,
    } = this.props;

    const createPlaidHandler = () => {
      window.plaidLinkHandler = window.Plaid.create({
        apiVersion,
        clientName,
        env,
        key: publicKey,
        onSuccess,
        product: ['auth', 'transactions'],
        selectAccount,
        token,
      });
    };

    loadDynamicScript(initializeURL, 'load-plaid')(createPlaidHandler);
  }

  render() {
    const { children, disabled = false, isText = false } = this.props;

    return (
      <Fragment>
        {isText ? (
          <PlaidTextLink onClick={handleOnClick}>{children}</PlaidTextLink>
        ) : (
          <PlaidButton
            type="button"
            aria-label="open bank account modal"
            onClick={handleOnClick}
            disabled={disabled}
          >
            {children}
          </PlaidButton>
        )}
      </Fragment>
    );
  }
}

export default PlaidLink;



// WEBPACK FOOTER //
// ./src/components/plaid-link/index.js